import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var languages = [{
  value: 'en-GB',
  alias: ['en'],
  title: 'English (GB)',
  title_en: 'English (GB)'
}, {
  value: 'en-US',
  alias: ['enUS'],
  title: 'English (US)',
  title_en: 'English (US)'
}, {
  value: 'de-DE',
  alias: ['de'],
  title: 'Deutsch (Du)',
  title_en: 'German (Du)'
}, {
  value: 'de-DE-Sie',
  alias: ['de-Sie'],
  title: 'Deutsch (Sie)',
  title_en: 'German (Sie)'
}, {
  value: 'fr-FR',
  alias: ['fr'],
  title: 'Français',
  title_en: 'French'
}, {
  value: 'es-ES',
  alias: ['es'],
  title: 'Español',
  title_en: 'Spanish'
}, {
  value: 'nl-NL',
  alias: ['nl'],
  title: 'Nederlands',
  title_en: 'Dutch'
}, {
  value: 'no-NO',
  alias: ['nn', 'nb', 'no'],
  title: 'Norsk',
  title_en: 'Norwegian'
}, {
  value: 'pt-PT',
  alias: ['pt'],
  title: 'Português',
  title_en: 'Portuguese'
}, {
  value: 'sv-SE',
  alias: ['se', 'sv'],
  title: 'Svenska',
  title_en: 'Swedish'
}, {
  value: 'zh-CN',
  alias: ['zh'],
  title: '普通话',
  title_en: 'Chinese'
}, {
  value: 'zh-TW',
  alias: ['zh-TW'],
  title: '繁體中文',
  title_en: 'Chinese (Traditional)'
}, {
  value: 'ja-JP',
  alias: ['ja', 'jp'],
  title: '日本語',
  title_en: 'Japanese'
}, {
  value: 'da-DK',
  alias: ['da'],
  title: 'Dansk',
  title_en: 'Danish'
}, {
  value: 'fi-FI',
  alias: ['fi'],
  title: 'Suomi',
  title_en: 'Finnish'
}, {
  value: 'hu-HU',
  alias: ['hu'],
  title: 'Magyar',
  title_en: 'Hungarian'
}, {
  value: 'it-IT',
  alias: ['it'],
  title: 'Italiano',
  title_en: 'Italian'
}, {
  value: 'pl-PL',
  alias: ['pl'],
  title: 'Polski',
  title_en: 'Polish'
}, {
  value: 'ro-RO',
  alias: ['ro'],
  title: 'Română',
  title_en: 'Romanian'
}, {
  value: 'ko-KR',
  alias: ['ko'],
  title: '한국어',
  title_en: 'Korean'
}, {
  value: 'th-TH',
  alias: ['th'],
  title: 'ไทย',
  title_en: 'Thai'
}];
function formatLanguageCode(code) {
  if (!code) {
    return null;
  }

  // Does the code exist...
  var _iterator = _createForOfIteratorHelper(languages),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item.value === code || item.alias && item.alias.includes(code)) {
        return item.value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (code.length > 2) {
    return formatLanguageCode(code.substr(0, 2));
  }
  return null;
}
function getLanguageTitle(item) {
  return "".concat(item === null || item === void 0 ? void 0 : item.title, " | ").concat(item === null || item === void 0 ? void 0 : item.title_en);
}
export { languages, formatLanguageCode, getLanguageTitle };